/* eslint-disable */
const internals = {
    /**
     * Variable
     */
    $this: $('.mod-form-calculator'),
    mainCostPer: 67,
    mainMultip: 111,
    checkBat (val) {
      let bat = 0
      switch (val) {
        case 'Lithium Ion':
          bat = 0.5;
          break;
        case 'Wet Cell':
          bat = 2;
          break;
        default:
          bat = 1;
      }
      return bat
    },
    checkBatteryRuntine (val) {
      let runtine = 0
      switch (val) {
        case '10 or more':
          runtine = 7;
          break;
        case '4 or less':
          runtine = 3;
          break;
        case '5':
        case '6':
          runtine = 4;
          break;
        case '7':
          runtine = 5;
          break;
        case '8':
          runtine = 6;
          break;
        default:
          runtine = 6;
      }
      return runtine
    },
    primaryVal(yearNew, electricalEquipment,mechanicalEquipment, raisedVal,upsVal,battVal,genVal,plantVal,equipmentType,batteryRuntineVal) {
      let costFloorTiles = 0
      if (raisedVal === 'NO') {
        costFloorTiles = 10000
      }
      const b91 = window.checkRedundancy(upsVal,electricalEquipment)*2
      const b92 = window.checkRedundancy(genVal,electricalEquipment)
      const g30 = b91*5
      const b84 = electricalEquipment
      const b101 = window.checkRedundancy(plantVal,mechanicalEquipment)
      let g51 = 0
      let costsIDEC = 0
      let g56 = 0
      let g50 = 0
      const costBattery = 25000*window.checkBatteryRuntine(batteryRuntineVal)
      let multipOther = 0
      if(equipmentType !== 'Chillers / Cooling Tower' || 23-(new Date().getFullYear() - yearNew)  > 10) {
        if(equipmentType === 'Air-Cooled Chillers') {
          g50 = b101*2
        } else {
          if(equipmentType === 'Chillers / Cooling Tower') {
            g50 = b101
          } else {
            g50 = 0
          }
        }
      } else {
        g50 = 0
      }
      if(equipmentType === 'Chillers / Cooling Tower') {
        g51 = b101
      }
      if(equipmentType === 'Chillers / Cooling Tower' || equipmentType === 'Air-Cooled Chillers') {
        g56 = b101*6
      }
      if(equipmentType === 'Other') {
        multipOther = b101*3
      }
      if(equipmentType === 'INDIRECT EVAPORTIVE COOLING') {
        costsIDEC = b101*1.5
      } else {
        if(equipmentType === 'Direct Evaporative') {
          costsIDEC = b101
        } else {
          costsIDEC = 0
        }
      }
      let multipCooling = 0
      if(equipmentType === 'Chillers / Cooling Tower' || equipmentType === 'Other') {
        multipCooling = b101
      }
      let multipCRAC = 0
      if(equipmentType === 'CRAC units') {
        multipCRAC = b101*2
      } else {
        if(equipmentType === 'DX RTUs') {
          multipCRAC = b101*1.1
        } else {
          multipCRAC = 0
        }
      }
      return [
        {
          // AED
          Costs: 3000,
          Multiplier: 1,
          Year: 8 - (new Date().getFullYear() - yearNew)
        },
        {
          // Doors
          Costs: 15000,
          Multiplier: 1,
          Year: 12 - (new Date().getFullYear() - yearNew)
        },
        {
          // Elevator
          Costs: 135000,
          Multiplier: 1,
          Year: 30 - (new Date().getFullYear() - yearNew)
        },
        {
          // Fire Extinguisher
          Costs: 500,
          Multiplier: electricalEquipment * 5,
          Year: 10 - (new Date().getFullYear() - yearNew)
        },
        {
          //Forklift
          Costs: 30000,
          Multiplier: 1,
          Year: 25 - (new Date().getFullYear() - yearNew)
        },
        {
          //Gates
          Costs: 7500,
          Multiplier: 1,
          Year: 12 - (new Date().getFullYear() - yearNew)
        },
        {
          //Parking Lot
          Costs: 350000,
          Multiplier: 1,
          Year: 10 - (new Date().getFullYear() - yearNew)
        },
        {
          //Rooftop
          Costs: 2000000,
          Multiplier: 1,
          Year: 15 - (new Date().getFullYear() - yearNew)
        },
        {
          //Trash Compactor
          Costs: 30000,
          Multiplier: 1,
          Year: 25 - (new Date().getFullYear() - yearNew)
        },
        {
          //Floor Tiles
          Costs: costFloorTiles,
          Multiplier: b84,
          Year: 5 - (new Date().getFullYear() - yearNew)
        }, {
          //AC Panel
          Costs: 20000,
          Multiplier: b91,
          Year: 30 - (new Date().getFullYear() - yearNew)
        }, {
          //ATS
          Costs: 25000,
          Multiplier: b91,
          Year: 30 - (new Date().getFullYear() - yearNew)
        }, {
          //Battery
          Costs: costBattery,
          Multiplier: b91*window.checkBat(battVal),
          Year: 8 - (new Date().getFullYear() - yearNew)
        }, {
          //Battery Charger
          Costs: 0,
          Multiplier: 0,
          Year: 8 - (new Date().getFullYear() - yearNew)
        }, {
          //Battery Monitoring
          Costs: 0,
          Multiplier: 0,
          Year: 8 - (new Date().getFullYear() - yearNew)
        }, {
          //Breaker
          Costs: 2000,
          Multiplier: 8*b91,
          Year: 15 - (new Date().getFullYear() - yearNew)
        }, {
          //Bus Ducts
          Costs: 75000,
          Multiplier: b91,
          Year: 30 - (new Date().getFullYear() - yearNew)
        }, {
          //Distribution Board
          Costs: 25000,
          Multiplier: b91,
          Year: 30 - (new Date().getFullYear() - yearNew)
        }, {
          //EPO System
          Costs: 15000,
          Multiplier: b91,
          Year: 30 - (new Date().getFullYear() - yearNew)
        }, {
          //Generator
          Costs: 950000,
          Multiplier: b92,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //Lighting
          Costs: 100000,
          Multiplier: 1,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //Lighting Inverter
          Costs: 2500,
          Multiplier: 2,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //Load Bank
          Costs: 7500,
          Multiplier: 0,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //MTS
          Costs: 17500,
          Multiplier: 0,
          Year: 40 - (new Date().getFullYear() - yearNew)
        }, {
          //PDU
          Costs: 31000,
          Multiplier: b91*5,
          Year: 30 - (new Date().getFullYear() - yearNew)
        }, {
          //RPP Cabinet
          Costs: 20600,
          Multiplier: g30*3,
          Year: 30 - (new Date().getFullYear() - yearNew)
        }, {
          //STS
          Costs: 12000,
          Multiplier: g30,
          Year: 30 - (new Date().getFullYear() - yearNew)
        }, {
          //Switch Gear
          Costs: 290000,
          Multiplier: b92,
          Year:30 - (new Date().getFullYear() - yearNew)
        }, {
          //Transformer
          Costs: 45000,
          Multiplier: b92,
          Year: 25 - (new Date().getFullYear() - yearNew)
        }, {
          //TVSS
          Costs: 3500,
          Multiplier: b92,
          Year: 5 - (new Date().getFullYear() - yearNew)
        }, {
          //UPS Module
          Costs: 200000,
          Multiplier: b91,
          Year: 15 - (new Date().getFullYear() - yearNew)
        }, {
          //UPS System
          Costs: 965000,
          Multiplier: 0,
          Year: 15 - (new Date().getFullYear() - yearNew)
        }, {
          //Utility
          Costs: 995000,
          Multiplier: 2,
          Year: 30 - (new Date().getFullYear() - yearNew)
        }, {
          //Fire Panel
          Costs: 35000,
          Multiplier: 1,
          Year: 12 - (new Date().getFullYear() - yearNew)
        }, {
          //Fire Pump
          Costs: 25000,
          Multiplier: 1,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //FM 200
          Costs: 125000,
          Multiplier: 1,
          Year: 15 - (new Date().getFullYear() - yearNew)
        }, {
          //Heat Detector
          Costs: 750,
          Multiplier: b84*15,
          Year: 10 - (new Date().getFullYear() - yearNew)
        }, {
          //Horns / Strobe
          Costs: 7500,
          Multiplier: b84*15,
          Year: 10 - (new Date().getFullYear() - yearNew)
        }, {
          //Preaction
          Costs: 275000,
          Multiplier: 1,
          Year: 25 - (new Date().getFullYear() - yearNew)
        }, {
          //Smoke Detector
          Costs: 200,
          Multiplier: b84*20,
          Year: 10 - (new Date().getFullYear() - yearNew)
        }, {
          //Air Compressor
          Costs: 7500,
          Multiplier: 1,
          Year: 12 - (new Date().getFullYear() - yearNew)
        }, {
          //IDEC / Direct Evap
          Costs: 400000,
          Multiplier: costsIDEC,
          Year: 15 - (new Date().getFullYear() - yearNew)
        }, {
          //Air Handler
          Costs: 52500,
          Multiplier: b101/2,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //BAS
          Costs: 175000,
          Multiplier: 1,
          Year: 12 - (new Date().getFullYear() - yearNew)
        }, {
          //Air-Cooled Chiller / Centrifugal Compressor
          Costs: 500000,
          Multiplier: g50,
          Year: 15 - (new Date().getFullYear() - yearNew)
        }, {
          //Chiller
          Costs: 950000,
          Multiplier: g51,
          Year: 23 - (new Date().getFullYear() - yearNew)
        }, {
          //Compressor
          Costs: 15000,
          Multiplier: 0,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //Condensing Unit
          Costs: 25000,
          Multiplier: 0,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //Cooling Tower
          Costs: 275000,
          Multiplier: multipCooling,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //CRAC
          Costs: 52500,
          Multiplier: multipCRAC,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //CRAH
          Costs: 52500,
          Multiplier: g56,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //Dry Cooler
          Costs: 25000,
          Multiplier: b101,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //Fan
          Costs: 2500,
          Multiplier: 0,
          Year: 15 - (new Date().getFullYear() - yearNew)
        }, {
          //Fuel Polisher
          Costs: 5000,
          Multiplier: b92,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //Fuel Pump
          Costs: 7500,
          Multiplier: b92,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //Fuel System
          Costs: 35000,
          Multiplier: b92,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //Fuel Tank
          Costs: 570000,
          Multiplier: b92,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //Humidifier
          Costs: 18000,
          Multiplier: b101,
          Year: 13 - (new Date().getFullYear() - yearNew)
        }, {
          //In Row Cooler
          Costs: 25000,
          Multiplier: mechanicalEquipment/2,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //Leak Detection
          Costs: 5000,
          Multiplier: g56,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //Pump
          Costs: 8000,
          Multiplier: g51,
          Year: 10 - (new Date().getFullYear() - yearNew)
        }, {
          //Sensor
          Costs: 500,
          Multiplier: b101*10,
          Year: 10 - (new Date().getFullYear() - yearNew)
        }, {
          //Variable Air Volume System
          Costs: 45000,
          Multiplier: 4,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //VFD
          Costs: 5000,
          Multiplier: b101*3,
          Year: 20 - (new Date().getFullYear() - yearNew)
        }, {
          //Water Heater
          Costs: 2500,
          Multiplier: 2,
          Year: 15 - (new Date().getFullYear() - yearNew)
        }, {
          //Water Tank
          Costs: 2000,
          Multiplier: 2,
          Year: 15 - (new Date().getFullYear() - yearNew)
        }, {
          //Water Treatment System
          Costs: 10000,
          Multiplier: 2,
          Year: 15 - (new Date().getFullYear() - yearNew)
        }, {
          //Other
          Costs: 50000,
          Multiplier: multipOther,
          Year: 10 - (new Date().getFullYear() - yearNew)
        }
      ]
    },
    checkTaxRate(val) {
      let taxRate = 0
      switch (val) {
        case 'Atlanta, GA':
          taxRate = 0.575;
          break;
        case 'Chicago, IL':
          taxRate = 2.16;
          break;
        case 'Dallas, TX':
          taxRate = 2;
          break;
        case 'New Albany, OH':
          taxRate = 2;
          break;
        case 'Northern VA':
          taxRate = 0.89;
          break;
        case 'Phoenix, AZ':
          taxRate = 0.61;
          break;
        case 'Portland, OR':
          taxRate = 0.9;
          break;
        case 'Silicon Valley, CA':
          taxRate = 0.79;
          break;
        case 'Calgary, AB':
          taxRate = 0.74;
          break;
        default:
          taxRate = 0.611;
        // code block
      }
      return taxRate;
    },
    checkMainCost(val) {
      let mainCost = 0;
      switch (true) {
        case (val < 2000):
          mainCost = 140;
          break;
        case (val < 4000):
          mainCost = 120;
          break;
        case (val < 6000):
          mainCost = 67;
            break;
        case (val < 12000):
          mainCost = 46;
          break;
        default:
          mainCost = 28;
      }
      return mainCost;
    },
    checkMaintenanceMultiplier(val) {
      let mainMul = 0
      switch (val) {
        case '< 1.35':
          mainMul = 1.1;
          break;
        case '1.35 - 1.6':
          mainMul = 1.05;
          break;
        default:
          mainMul = 1.01;
      }
      return mainMul;
    },
    checkupsRedundancy(val, electricalEquipment) {
      let usp = 0
      switch (val) {
        case 'None':
          usp = 0;
          break;
        case 'N':
          usp = 1;
          break;
        case 'N + 1':
          usp = 1 + ((electricalEquipment + 1) / electricalEquipment) / 10;
          break;
        default:
          usp = 2;
      }
      return parseFloat(usp.toFixed(4));
    },
    checkGen(val, electricalEquipment) {
      let gen = 0
      switch (val) {
        case 'None':
          gen = 0;
          break;
        case 'N':
          gen = 1;
          break;
        case 'N + 1':
          gen = 1 + ((electricalEquipment + 1 ) / electricalEquipment) / 10;
          break;
        default:
          gen = 2;
      }
      return parseFloat(gen.toFixed(4));
    },
    checkMechanical(val, electricalEquipment) {
      let mechanical = 0
      switch (val) {
        case 'None':
          mechanical = 0;
          break;
        case 'N':
          mechanical = 1;
          break;
        case 'N + 1':
          mechanical = 1 + ((electricalEquipment + 1 ) / electricalEquipment) / 10;
          break;
        default:
          mechanical = 2;
      }
      return parseFloat(mechanical.toFixed(4))
    },
    checkRedundancy(val,mechanicalEquipment) {
      let redun = 0
      switch (val) {
        case 'None':
          redun = mechanicalEquipment/2;
          break;
        case 'N':
          redun = mechanicalEquipment;
          break;
        case 'N + 1':
          redun = mechanicalEquipment + 1;
          break;
        default:
          redun = mechanicalEquipment * 2;
      }
      return redun;
    },
    sumArr(arr) {
      let r = 0;
      $.each(arr, function (_i, v) {
        r += +v;
      });
      return r;
    },
    percentyear(year) {
      let percent = 0
      switch (year) {
        case 2:
          percent = .2;
          break;
        case 5:
          percent = .25;
          break;
        default:
          percent = .3;
      }
      return percent;
    },
    suminYear(year, valArr) {
      const twoYear = valArr.map(el => {
        // console.log(el.Multiplier)
        if (el.Year < year) {
          return Math.round(el.Costs * el.Multiplier)
        }
        return 0
      })
      const sum = window.sumArr(twoYear)
      // console.log(twoYear)
      return parseInt(sum + sum * window.percentyear(year)).toLocaleString()
    },
    calc() {
      const $twoYear = $('#year-capEx-forecast-2')
      const $fiveYear = $('#year-capEx-forecast-5')
      const $tenYear = $('#year-capEx-forecast-10')
      const $selectRaisedAccessFloor = $('#select-raised-access-floor')
      const $annualMaintenanceCost = $('#annual-maintenance-cost')
      const $annualTaxesInsurance = $('#annual-taxes-insurance')
      const $year = $('#select-year-last-commissioned')
      const $city = $('#select-city-us')
      const $cityCanada = $('#select-city-canada')
      const $actualIT = $('#ActualCriticalITLoad')
      const $estPue = $('#select-estimated-annualized-PUE')
      const electricalEquipment = $actualIT.val() / 0.75 / 2000
      const mechanicalEquipment = $actualIT.val() / 0.9 / 1000
      const $upsRedundancy = $('#select-UPS')
      const $genRedundancy = $('#select-generator-redundancy')
      const $planRedundancy = $('#select-plan-redundancy')
      const $batteryType = $('#select-battery-type')
      const $type = $('#select-equipment-type')
      const $typev2 = $('#select-equipment-type-v2')
      const $currentPower = $('#CurrentPowerDensity')
      const $itWhite = $('#ITWhiteSpace')
      const $batteryRuntine = $('#select-battery-runtime')
      let cityval = $city.val()
      if($city.parents('.form-select-c8').hasClass('hidden')) {
        cityval = $cityCanada.val()
      }
      let typeVal = $type.val()
      if($type.parents('.form-select-c8').hasClass('hidden')) {
        typeVal = $typev2.val()
      }
      $('#ITWhiteSpace,#ActualCriticalITLoad').on('keypress', (e) => {
        if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
          e.preventDefault()
        }
      })
      const raisedVal = $selectRaisedAccessFloor.val()
      const C8 = (window.checkupsRedundancy($upsRedundancy.val(), electricalEquipment) + window.checkGen($genRedundancy.val(), electricalEquipment)
        + window.checkMechanical($planRedundancy.val(), electricalEquipment)) * 3
      const maintenanceMultiplier = window.checkMaintenanceMultiplier($estPue.val())
      const mainCost = window.checkMainCost($actualIT.val())
      const taxRate = window.checkTaxRate(cityval)
      const annualMaintenanceCost = $actualIT.val() * mainCost * maintenanceMultiplier * (100 + C8) / 100

      const annuaTaxe = (8 + taxRate) * $actualIT.val() * 12 * maintenanceMultiplier
      const currentPowerVal = 1000*$actualIT.val()/$itWhite.val()
      if(currentPowerVal >= 0 && currentPowerVal !== Infinity) {
        $currentPower.val(Math.round(currentPowerVal))
      } else {
        if(parseInt($itWhite.val()) === 0) {
          $currentPower.val('')
        }
      }
      let yearNew = 0
      if ($year.val() === 'Before 2000') {
        yearNew = 2000
      } else {
        yearNew = parseInt($year.val())
      }
      // 2 year - 5 year - 10 year
      const valArr = window.primaryVal(yearNew, electricalEquipment,mechanicalEquipment, raisedVal,$upsRedundancy.val(),$batteryType.val(),$genRedundancy.val(),$planRedundancy.val(),typeVal,$batteryRuntine.val())
      if($actualIT.val() !== '' &&  $itWhite !== '') {
        $twoYear.text(window.suminYear(2, valArr))
        $fiveYear.text(window.suminYear(5, valArr))
        $tenYear.text(window.suminYear(10, valArr))
      } else {
        $twoYear.text(0)
        $fiveYear.text(0)
        $tenYear.text(0)
      }

      if($annualMaintenanceCost.length) {
        $annualMaintenanceCost.text(parseInt(annualMaintenanceCost).toLocaleString())
      }
      if($annualTaxesInsurance.length) {
        $annualTaxesInsurance.text(parseInt(annuaTaxe).toLocaleString())
      }
    },
    inint () {
      this.$this.on('change', 'input[type="text"],input[type="number"],select', () => {
        internals.calc()
      })
    }
  }

  const BannerTeams = (() => {
    if (internals.$this.length) {
      window.checkBatteryRuntine = internals.checkBatteryRuntine
      window.checkBat = internals.checkBat
      window.percentyear = internals.percentyear
      window.sumArr = internals.sumArr
      window.suminYear = internals.suminYear
      window.primaryVal = internals.primaryVal
      window.checkMaintenanceMultiplier = internals.checkMaintenanceMultiplier
      window.checkTaxRate = internals.checkTaxRate
      window.checkMainCost = internals.checkMainCost
      window.checkupsRedundancy = internals.checkupsRedundancy
      window.checkGen = internals.checkGen
      window.checkMechanical = internals.checkMechanical
      window.checkRedundancy = internals.checkRedundancy
      window.calc = internals.calc
      internals.calc()
      internals.inint()
    }
  })()
  export default BannerTeams